import { createReducer, on } from '@ngrx/store';
import { pageInContext, PageNameTypes } from '../utilities/Constants';
import { ViewPageActions } from '../../transaction-view/actions';
import {
  ConfirmationPageActions,
  MasterTransactionsTableActions,
  ReviewPageActions,
  StandingAuthorizationsTableActions,
  TransactionFormActions,
  TransactionsTableActions,
} from '../../create-request/actions';
import {
  StandingAuthConfirmationPageActions,
  StandingAuthFormActions,
  StandingAuthMasterStatusTableActions,
  StandingAuthReviewPageActions,
} from '../../standing-authorizations/actions';
import { InitReleaseActions } from '../../initiate-and-release/actions';
import { AccountInfoActions } from '../../account-info-header/actions';

export const viewInContextKey = 'step';

export const initialviewInContextState: PageNameTypes = pageInContext.input;

export const createRequestStepReducer = createReducer(
  initialviewInContextState,
  on(StandingAuthorizationsTableActions.loadViewPage, () => {
    return pageInContext.view;
  }),
  on(TransactionsTableActions.loadViewPage, () => {
    return pageInContext.view;
  }),
  on(MasterTransactionsTableActions.loadViewPage,
    StandingAuthMasterStatusTableActions.loadViewPage, () => {
    return pageInContext.viewMsv;
  }),
  on(
    TransactionFormActions.loadReviewPage,
    StandingAuthFormActions.loadReviewPage,
    () => {
      return pageInContext.review;
    }
  ),
  on(
    ReviewPageActions.loadConfirmationPage,
    ReviewPageActions.loadConfirmationPageWithoutAcknowledgeCall,
    StandingAuthReviewPageActions.loadConfirmationPage,
    StandingAuthReviewPageActions.loadEmptyConfirmationPage,
    () => {
      return pageInContext.confirmation;
    }
  ),
  on(
    ReviewPageActions.editClicked,
    StandingAuthReviewPageActions.editClicked,
    InitReleaseActions.backButtonClicked,
    AccountInfoActions.updateUserContext,
    () => {
      return pageInContext.input;
    }
  ),
  on(
    ReviewPageActions.cancelClicked,
    StandingAuthReviewPageActions.cancelClicked,
    () => {
      return pageInContext.input;
    }
  ),
  on(ConfirmationPageActions.createAnotherRequestClicked,
    StandingAuthConfirmationPageActions.createNewStandingAuthClicked,
    StandingAuthConfirmationPageActions.returnStandingAuthClicked,
    () => {
    return pageInContext.input;
  }),
  on(ConfirmationPageActions.viewTransactionStatusClicked, () => {
    return pageInContext.input;
  }),
  on(ViewPageActions.backButtonClicked,
    ViewPageActions.backButtonClickedFromMsv, () => {
    return pageInContext.input;
  }),
  on(ViewPageActions.editButtonClicked,
    ViewPageActions.startTransactionButtonClicked,
    ViewPageActions.editProfileClicked, () => {
    return pageInContext.input;
  })
);
